import TripsTimelineViewContainer from './TripsTimelineViewContainer';

export default TripsTimelineViewContainer;
